import React from 'react';
import classnames from 'classnames';

const Spinner = props => {
	const { msg, mask = true } = props;
	const loadingMsg = msg || 'Loading';
	const spinnerClassname = classnames('common-ui-spinner', {
		'common-ui-spinner-mask': mask === true,
	});

	return (
		<div className={spinnerClassname}>
			<div className="spinner-content">
				<div
					className="spinner-image"
					role="img"
					aria-label="Loading content"
					aria-live="polite"
				/>
				<div className="spinner-message" data-qa="ui-spinner" {...{ dataqa: 'ui-spinner' }}>
					{loadingMsg}
				</div>
			</div>
		</div>
	);
};

export default Spinner;
